<template>
  <v-card flat>
    <v-list dense>
      <template v-for="item in accessItems">
        <v-list-group
          v-if="item.children"
          :key="item.text"
          v-model="item.active"
          :prepend-icon="item.icon"
          no-action
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title v-text="item.text"></v-list-item-title>
            </v-list-item-content>
          </template>
          <v-list-item
            v-for="(child, i) in item.children"
            :key="i"
            :to="child.route"
            :href="child.href"
            :target="child.route ? '_self' : '_blank'"
            :class="[
              {
                'router-link-active--false': child.route && activeMenu != child.route.name,
              },
              {
                'v-list-item--active': child.route && activeMenu == child.route.name,
              },
            ]"
          >
            <v-list-item-content>
              <v-list-item-title v-text="child.text"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
        <v-list-item
          v-else
          :key="item.text"
          v-model="item.active"
          link
          :to="item.route"
          :class="{
            'router-link-active--false': item.route && activeMenu != item.route.name,
          }"
          @click="item.action && handleItemClick(item)"
        >
          <v-list-item-action>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ item.text }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-list>
  </v-card>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  data() {
    return {
      items: [
        {
          icon: 'mdi-account',
          active: false,
          text: 'Home',
          route: { path: '/sales' },
        },
        {
          icon: 'mdi-home',
          active: false,
          text: '선정산',
          route: { path: '/earlypay-intro' },
        },
        {
          icon: 'mdi-logout',
          active: false,
          text: '로그아웃',
          action: 'signout', // 클릭 시 실행할 메소드명
        },
        {
          icon: 'mdi-robot',
          active: false,
          text: 'AI 장사비서 beta',
          route: { path: '/aicrm' },
        },
        // {
        //   icon: 'mdi-account',
        //   active: false,
        //   text: 'my',
        //   route: { name: 'main' },
        // },
        // {
        //   icon: 'mdi-account',
        //   active: false,
        //   text: 'my',
        //   children: [
        //     { text: '마이페이지', route: { name: 'my' } },
        //     { text: '사업장정보등록', route: { name: 'my/store/register' } },
        //     { text: '사업자정보등록', route: { name: 'my/business/register' } },
        //     { text: '상점연동', route: { name: 'my/malls' } },
        //     { text: '계좌등록', route: { name: 'my/account/register' } },
        //   ],
        // },
      ],
    }
  },
  computed: {
    activeMenu() {
      const name = this.$route.name
      if (name == null) {
        return ''
      }

      // this.$route.matched[0] : parent 라우터 또는 자기 자신
      const firstMatchedRouter = this.$router.options?.routes?.filter((router) => {
        return router?.path === this.$route.matched[0]?.path
      })[0]

      return firstMatchedRouter ? firstMatchedRouter.name : ''
    },
    accessItems() {
      const items = this.items.filter((v) => {
        return v.auth == null || this.$store.getters['auth/hasAnyRole'](v.auth)
      })

      return items
    },
  },
  methods: {
    ...mapActions('auth', {
      storeSignout: 'signout',
    }),
    signout() {
      console.log('로그아웃!')
      this.storeSignout()
      //this.$router.replace('/')
      this.$router.replace('/signin')
    },
    handleItemClick(item) {
      if (item.action) {
        this[item.action]()
      }
    }
  },
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/common/_variables.scss';

.router-link-active--false {
  color: $black;
  &::before {
    opacity: 0;
  }
}
</style>
